import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, { useEffect, useState } from 'react';
import { GENDERS, LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode, USER_ROLE_LIST } from "@app/constants/Common";
import { requestSaveUser, requestSaveEndPriDate, requestAdminResetPasswordUser } from "@app/services/UserService";
import DatePicker from "react-datepicker";

const CreateUserModal = (props) => {
    const [user, setUser] = useState({
        id: '', full_name: '', username: '', gender: '', email: '', phone: '',
        start_pri_input_date: '', end_pri_input_date: '', is_active: true,
        can_update_email_invite_job: true,
        call_chat_before_uv_reject_provide_email: true,
    });

    const [isLoading, setIsLoading] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [canInputPriInputDate, setCanInputPriInputDate] = useState(true)
    const [canEditEndPriDate, setCanEditEndPriDate] = useState(false)
    const [isEditEndPriDate, setIsEditEndPriDate] = useState(false)
    const [userLoginInfo, setUserLoginInfo] = useState({})
    const { isShow, userInput, onClose } = props

    useEffect(() => {
        if (userInput) {
            setIsEdit(true)
            setUser({
                id: userInput.id,
                full_name: userInput.full_name,
                first_name: userInput.first_name,
                username: userInput.username,
                gender: userInput.gender,
                email: userInput.email,
                phone: userInput.phone,
                groups_id: userInput.groups,
                is_active: userInput.is_active,
                can_update_email_invite_job: userInput.can_update_email_invite_job,
                call_chat_before_uv_reject_provide_email: userInput.call_chat_before_uv_reject_provide_email,
                start_pri_input_date: userInput.start_pri_input_date,
                end_pri_input_date: userInput.end_pri_input_date,
            })
            if (userInput.start_pri_input_date && userInput.end_pri_input_date) {
                setCanInputPriInputDate(false)
            } else {
                setCanInputPriInputDate(true)
            }

            if (userInput.id && userInput.start_pri_input_date && userInput.end_pri_input_date
                && userInput.end_pri_input_date > new Date().toISOString().slice(0, 10)) {
                setCanEditEndPriDate(true)
            }
        } else {
            setIsEdit(false)
            setUser({
                id: '', full_name: '', first_name: '', username: '',
                gender: '', email: '', phone: '',
                start_pri_input_date: '', end_pri_input_date: '', is_active: true,
                can_update_email_invite_job: true,
                call_chat_before_uv_reject_provide_email: true,
            })
            setCanEditEndPriDate(false)
        }
        if (localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [userInput]);

    const onSaveUser = () => {
        if (!user.full_name) {
            alert("Vui lòng nhập Họ & tên.")
            return;
        }
        if (!user.first_name) {
            alert("Vui lòng nhập Tên.")
            return;
        }
        if (!user.username) {
            alert("Vui lòng nhập Tên đăng nhập.")
            return;
        }
        if (!user.email) {
            alert("Vui lòng nhậ Email.")
            return;
        }
        if (!user.groups_id) {
            user.groups_id = USER_ROLE_LIST[0].value
        }
        setIsLoading(true)

        user.is_active = (user.is_active === true || user.is_active === 'true')
        user.can_update_email_invite_job = (user.can_update_email_invite_job === true || user.can_update_email_invite_job === 'true')
        user.call_chat_before_uv_reject_provide_email = (user.call_chat_before_uv_reject_provide_email === true || user.call_chat_before_uv_reject_provide_email === 'true')
        requestSaveUser(user).then((res) => {
            console.log(`Response-save user:${JSON.stringify(res)}`);
            if (res.sts_code === ResponseCode.SUCCESS) {
                onClose(true)
            } else {
                alert(res.message)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onSaveUserPriEndDate = () => {
        if (!user.end_pri_input_date) {
            alert("Vui lòng nhập ngày NL ưu tiên kết thúc.")
            return;
        }

        const strStartDate = typeof user.start_pri_input_date === 'string' ?
            user.start_pri_input_date : user.start_pri_input_date.toISOString().slice(0, 10)
        const strEndDate = typeof user.end_pri_input_date === 'string' ?
            user.end_pri_input_date : user.end_pri_input_date.toISOString().slice(0, 10)
        if (strEndDate < strStartDate) {
            alert("Ngày kết thúc phải sau ngày bắt đầu.")
            return;
        }

        if (userInput.end_pri_input_date && strEndDate >= userInput.end_pri_input_date) {
            alert(`Ngày kết thúc mới phải sớm hơn ngày ${userInput.end_pri_input_date.replaceAll("-", "/")}.`)
            return;
        }

        const currentDate = new Date().toISOString().slice(0, 10)
        if (strEndDate < currentDate) {
            alert("Ngày kết thúc phải là ngày tương lai.")
            return;
        }

        setIsLoading(true)
        const requestBody = { user_id: user.id, end_pri_input_date: user.end_pri_input_date }
        requestSaveEndPriDate(requestBody).then((res) => {
            console.log(`Response-save user:${JSON.stringify(res)}`);
            if (res.sts_code === ResponseCode.SUCCESS) {
                setIsEditEndPriDate(false)
                alert("Cập nhật ngày kết thúc NL ưu tiên thành công.")
            } else {
                alert(res.message)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onResetPassword = () => {
        if (window.confirm("Bạn chắc chắn muốn rest password.")) {
            setIsLoading(true)
            requestAdminResetPasswordUser({ user_id: user.id }).then((res) => {
                if (res.sts_code === ResponseCode.SUCCESS) {
                    alert(`Reset password thành công. Mật khẩu mới là: ${res.content.new_password}`)
                } else {
                    alert(res.message || "Reset password thất bại.")
                }
            }).catch((error) => {
                console.log(`Error:${JSON.stringify(error)}`);
                alert("Có lỗi xảy ra trong quá trình reset password.")
            }).finally(() => {
                setIsLoading(false);
            });
        }
    }

    const setUserItem = (event, fieldName) => {
        if (fieldName === 'end_pri_input_date' || fieldName === 'start_pri_input_date') {
            user[fieldName] = event
        } else {
            user[event.target.name] = event.target.value
        }
        setUser({ ...user })
    }

    return (
        <>
            <Modal show={isShow}
                size={'lg'}
                onHide={() => onClose()}
                animation={false}>
                <Modal.Header>
                    <Modal.Title>{userInput ? "Thông tin user" : "Nhập thông tin user mới"}</Modal.Title>
                    <div>
                        {isEdit && userLoginInfo.is_superuser &&
                            <Button variant='primary' className={'mr-2'} size={'sm'} onClick={() => onResetPassword()} disabled={isLoading}>
                                Reset password
                            </Button>
                        }
                        <Button variant='secondary' size={'sm'} onClick={() => onClose()}>
                            Close
                        </Button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <label className={'w-100'}>Họ và tên</label>
                                <input type='text' className='form-control' placeholder=''
                                    value={user.full_name}
                                    name={'full_name'} onChange={event => setUserItem(event)} />
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <label className={'w-100'}>Tên</label>
                                <input type='text' className='form-control' placeholder=''
                                    value={user.first_name}
                                    name={'first_name'} onChange={event => setUserItem(event)} />
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <label className={'w-100'}>Tên đăng nhập</label>
                                <input type='text' className='form-control' placeholder=''
                                    disabled={isEdit}
                                    value={user.username}
                                    name={'username'} onChange={event => setUserItem(event)} />
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <label className={'w-100'}>Email</label>
                                <input type='email' className='form-control' placeholder=''
                                    disabled={isEdit}
                                    value={user.email}
                                    name={'email'} onChange={event => setUserItem(event)} />
                            </div>
                        </div>

                        {/*<div className='col-sm-12'>*/}
                        {/*    <div className='form-group'>*/}
                        {/*        <label className={'w-100'}>Số ĐT</label>*/}
                        {/*        <input type='text' className='form-control' placeholder=''*/}
                        {/*               value={user.phone}*/}
                        {/*               name={'phone'} onChange={event => setUserItem(event)}/>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <label className={'w-100'}>Giới tính</label>
                                <select className='form-control'
                                    name={'gender'}
                                    value={user.gender}
                                    onChange={event => setUserItem(event)}>
                                    <option value=''>&nbsp;</option>
                                    {GENDERS.map(item => {
                                        return <option value={item.toLowerCase()} key={`gender_${item}`}>{item}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <label className={'w-100'}>Vai trò</label>
                                <select className='form-control'
                                    name={'groups_id'}
                                    value={user.groups_id}
                                    onChange={event => setUserItem(event)}>
                                    {USER_ROLE_LIST.map(item => {
                                        return <option value={item.value}>{item.name}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className={"row col-sm-12 pr-0"}>
                            <div className={'w-100'}>
                                <label className={'ml-1'}>Thời gian NL ưu tiên</label>

                                {canEditEndPriDate &&
                                    <>
                                        {!isEditEndPriDate &&
                                            <Button className={'btn btn-default float-right btn-sm'}
                                                type={"button"} onClick={() => setIsEditEndPriDate(true)}>Edit</Button>
                                        }
                                        {isEditEndPriDate &&
                                            <>
                                                <Button className={'btn btn-primary float-right btn-sm ml-2'}
                                                    type={"button"} onClick={() => onSaveUserPriEndDate()}>Save</Button>
                                                <Button className={'btn btn-default float-right btn-sm'}
                                                    type={"button"} onClick={() => setIsEditEndPriDate(false)}>
                                                    Cancel</Button>
                                            </>
                                        }
                                    </>
                                }
                            </div>
                            <div className='col-sm-6'>
                                <div className='form-group'>
                                    <DatePicker
                                        disabled={!canInputPriInputDate}
                                        selected={user.start_pri_input_date ? new Date(user.start_pri_input_date) : ''}
                                        dateFormat={"dd/MM/yyyy"}
                                        onChange={(value) => setUserItem(value, 'start_pri_input_date')}
                                        className='form-control' />
                                </div>
                            </div>
                            <div className='col-sm-6 pr-0'>
                                <div className='form-group'>
                                    <DatePicker
                                        disabled={!canInputPriInputDate && !isEditEndPriDate}
                                        selected={user.end_pri_input_date ? new Date(user.end_pri_input_date) : ''}
                                        dateFormat={"dd/MM/yyyy"}
                                        onChange={(value) => setUserItem(value, 'end_pri_input_date')}
                                        className='form-control' />
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <label className={'w-100'}>Trạng thái</label>
                                <select className='form-control'
                                    name={'is_active'}
                                    value={user.is_active}
                                    onChange={event => setUserItem(event)}>
                                    <option value='true'>Active</option>
                                    <option value='false'>Block</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <label className={'w-100'}>Có thể email mời Job</label>
                                <select className='form-control'
                                    name={'can_update_email_invite_job'}
                                    value={user.can_update_email_invite_job}
                                    onChange={event => setUserItem(event)}>
                                    <option value='true'>ON</option>
                                    <option value='false'>OFF</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <label className={'w-100'}>Call Chat trước vì UV từ chối cho email</label>
                                <select className='form-control'
                                    name={'call_chat_before_uv_reject_provide_email'}
                                    value={user.call_chat_before_uv_reject_provide_email}
                                    onChange={event => setUserItem(event)}>
                                    <option value='true'>ON</option>
                                    <option value='false'>OFF</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='button'
                        className='btn btn-primary'
                        isLoading={isLoading}
                        disabled={
                            isLoading || isEditEndPriDate
                        }
                        onClick={() => {
                            onSaveUser()
                        }}
                    >
                        <i className='fas fa-save mr-2' />
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CreateUserModal;
